const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the Invitation Manager Directive to display a list or table with users to manage
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 * @argument {Resource} Users the resource defined to get and set Invitation data
 */
app.directive('invitationsManager', ['Application', 'AdminUsers', 'AccessHelper', 'Users', '$translate', function (Application, AdminUsers, AccessHelper, Users, $translate) {
  return {
    restrict: 'E',
    scope: {
      refresh: '=',
      callRefresh: '&'
    },
    replace: true,
    template: require('../../templates/directives/invitations-manager.html'),
    controller: ['$scope', function ($scope) {
      var self = this;

      self.allowance = {
        add: AccessHelper.isAllowed(['admin', 'users', 'add'], null, ['admin']),
        edit: AccessHelper.isAllowed(['admin', 'users', 'edit'], null, ['admin']),
        view: AccessHelper.isAllowed(['admin', 'users', 'view'], null, ['admin']),
        suspend: AccessHelper.isAllowed(['admin', 'users', 'suspend'], null, ['admin']),
        password_reset: AccessHelper.isAllowed(['admin', 'users', 'password_reset'], null, ['admin'])
      };

      if (!self.allowance.view) {
        Application.navigation.goTo('/explore');
        return;
      }

      self.showSuspendConfirmation = false;
      self.showReminderConfirmation = false;
      self.reminded = {};
      self.invitations = [];
      self.per_page = 20;
      self.invitationsRemoved = 0;
      self.selection = [];
      self.selectionBlock = {};
      self.currentTab = 'invites';
      self.loading = false;
      self.allReminded = false;
      self.restrictions = {last_login: '$exists,false'};

      self.editUser = function(user) {
        if (!user._id) {
          return;
        }

        Application.navigation.goTo('/edit/users/' + user._id);
      };

      var getStandardQuery = function(){
        return {
          subresource: '',
          page: 1,
          per_page: self.per_page,
          last_login: '$exists,false',
          sort: 'createdAt,-1'
        };
      };

      self.query = getStandardQuery();

      self.initialize = function () {
        self.load();
      };

      self.load = function () {
        self.usersLoading = true;
        AdminUsers.find(self.query, function (invitations) {
          self.invitations = invitations;
          self.invitationsRemoved = 0;
          self.usersLoading = false;
        }, function (error) {
          self.usersLoading = false;
          console.log('Error getting users:', error);
        });
      };
      self.previous = function () {
        if (self.query.page === 1) {
          return;
        }
        self.query.page--;
        self.load();
      };
      self.next = function () {
        if (self.invitations.length !== self.per_page) {
          return;
        }
        self.query.page++;
        self.load();
      };
      self.select = function (id, user) {
        self.selectionBlock[id] = user;
        var index = self.selection.indexOf(id);
        if (index === -1) {
          self.selection.push(id);
          return;
        }
        self.selection.splice(index, 1);
      };
      self.newFilter = function(opts) {
        self.query = getStandardQuery();
        self.searching = false;
        if (opts && typeof opts === 'object' && Object.keys(opts).length) {
          self.searching = true;
        }
        if (!opts) {
          self.load();
          return;
        }
        self.query.page = 1;

        for (var key in opts) {
          self.query[key] = opts[key];
        }
        self.usersLoading = true;
        AdminUsers.find(self.query).$promise.then(function (invitations) {
          self.invitationsRemoved = 0;
          self.invitations = invitations;
          self.usersLoading = false;
        });
      };
      self.image = function (user) {
        if (user.image) {
          return user.image.replace('http:', 'https:').replace('http%', 'https%');
        }
        return 'img/avatar-default.png';
      };
      self.goToAddUsers = function () {
        Application.navigation.goTo('users/add');
      };
      self.confirmSuspend = function () {
        self.showSuspendConfirmation = true;
      };
      self.cancelSuspend = function () {
        self.selection.length = 0;
        self.showSuspendConfirmation = false;
      };
      self.remindUser = function(invite, all) {
        self.loading = true;
        var toInvite;
        if(invite && self.reminded[invite._id]) {
          $translate('inviteManager.reminder_already_sent', {
            email: invite.email,
          }).then(function (translation) {
            Application.messaging.addMessage({type: 'information', duration: 5, text: translation});
          });
          return;
        }
        if(self.allReminded) {
          Application.messaging.addMessage({type: 'information', duration: 5, text: self.translations['inviteManager.all_users_already_reminded']});
          return;
        }
        if (all) {
          toInvite = [];
        }
        if (invite) {
          toInvite = [invite._id];
        }

        Users.reinvite({}, {users: toInvite, force: true}, function(data) {
          self.loading = false;
          if (invite) {
            $translate('inviteManager.reminder_sent_success_to', {
              email: invite.email,
            }).then(function (translation) {
              Application.messaging.addMessage({type: 'success', duration: 5, text: translation});
            });
            self.reminded[invite._id] = true;
            return;
          }
          self.showReminderConfirmation = false;
          self.selectionBlock = {};
          self.selection = [];
          Application.messaging.addMessage({type: 'success', duration: 5, text: self.translations['inviteManager.all_users_unlogged_reminded']});
          self.allReminded = true;
        }, function(error) {
          Application.messaging.addMessage({type: 'error', duration: 5, text: self.translations['inviteManager.error_resending_invite']});
          self.loading = false;
        });
      };
      self.suspend = function () {
        self.loading = true;

        Users.suspend({}, {users: self.selection}).$promise
        .then(function(results) {
          for (var i = 0; i < self.selection.length; i++) {
            var id = self.selection[i];
            for (var index = 0; index < self.invitations.length; index++) {
              if (self.invitations[index]._id !== id) {
                continue;
              }
              self.invitations.splice(index, 1);
              self.invitationsRemoved++;
              break;
            }
          }
          self.cancelSuspend();
          self.loading = false;
          $scope.callRefresh({type: 'pending'});
          Application.messaging.addMessage({type: 'success', text: self.translations['inviteManager.all_invites_suspended'], duration: 5});
        }, function(error) {
          self.loading = false;
          Application.messaging.addMessage({type: 'error', text: self.translations['inviteManager.some_invites_not_suspended'], duration: 5});
        });

      };

      $scope.$watch('refresh', function(newVal, oldVal) {
        if (newVal && !oldVal) {
          self.query = getStandardQuery();
          self.searching = false;
          self.load();
          $scope.refresh = false;
        }
      });

      $translate([
        'modules.notifications.users_wereDeleted',
        'inviteManager.all_users_already_reminded',
        'inviteManager.all_users_unlogged_reminded',
        'inviteManager.error_resending_invite',
        'inviteManager.all_invites_suspended',
        'inviteManager.some_invites_not_suspended'
      ]).then(function(data){
          self.translations = data;
          self.initialize();
      });

    }],
    controllerAs: 'invites'
  };
}]);